import type { Email } from 'types/Email';
import type { Maybe } from 'types/UtilityTypes';

import { normalizePortalLoadIdToNumericCore } from './normalizePortalLoadId';

/**
 * When the normalized `loadId` field is empty, also use `email.biddingPortalLoadReference`.
 * Set `false` when the user has edited `loadId` (e.g. cleared the input) so we do not submit a
 * hidden email ref.
 * @default true
 */
export type ResolveNormalizedSubmitBidLoadIdOptions = {
  inferEmailWhenFormLoadIdEmpty?: boolean;
  normalizeLoadId?: (raw: string) => string;
};

/**
 * Submit-bid load id: normalized `loadId` from the quick-quote form, optionally then the email
 * thread's `biddingPortalLoadReference`.
 *
 * Matches the server submit-bid path in `useQuoteHandlers`.
 */
export function resolveNormalizedSubmitBidLoadId(
  loadIdFromForm: string,
  email: Maybe<Email>,
  options?: ResolveNormalizedSubmitBidLoadIdOptions
): string {
  const normalizeLoadId =
    options?.normalizeLoadId ?? normalizePortalLoadIdToNumericCore;
  const fromForm = normalizeLoadId(loadIdFromForm);
  if (fromForm) {
    return fromForm;
  }

  if (options?.inferEmailWhenFormLoadIdEmpty === false) {
    return '';
  }

  return normalizeLoadId(email?.biddingPortalLoadReference?.trim() ?? '');
}
